(ns minorodata.connections.sources.mongodb
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id                    "mongodb"
   :name                  "MongoDB"
   :description           "A general purpose, document-based, distributed database"
   :image-source          "mongodb.svg"
   :tags                  ["data-import"]
   :enabled               true
   :message-queue-enabled true


   :preview-formatter
   (fn [source]
     (str "DB: "
          (get-in source [:source-db-creds :dbname])
          ", server: "
          (get-in source [:source-db-creds :host])))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [access-type auth-dbname dbname
                    description extra hostname
                    name password port url user
                    bastion-hostname bastion-user bastion-port private-key
                    has-bastion? srv-conn?]} data]
        {:source-type "mongodb"
         :name        name
         :description description

         :source
         (cond-> {:source-db-creds {:access-type access-type
                                    :auth-dbname auth-dbname
                                    :dbname      dbname
                                    :dbtype      "mongodb"
                                    :extra       extra
                                    :host        hostname
                                    :port        port
                                    :password    password
                                    :url         url
                                    :user        user
                                    :srv-conn?  srv-conn?}}

           (and has-bastion?
                (every? some? [bastion-hostname bastion-user]))
           (assoc :bastion {:host     bastion-hostname
                            :user     bastion-user
                            :port     bastion-port
                            :db-host  hostname
                            :private-key private-key}))}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [source-db-creds bastion]} source
            {:keys [host user db-host private-key port]} bastion
            source-host  (:host source-db-creds)
            has-bastion? (if (every? some? [host user port])
                           true
                           false)
            srv-conn?    (true? (:srv-conn? source-db-creds))]
        (merge (select-keys source-db-creds [:access-type :auth-dbname :dbname
                                             :extra :password :port :url :user])
               {:hostname         source-host
                :name             name
                :description      description
                :bastion-hostname host
                :bastion-user     user
                :bastion-port     port
                :private-key      private-key
                :srv-conn?        srv-conn?
                :has-bastion?     has-bastion?})))

    :validate (constantly nil)

    :id       :mongodb-form

    :blocks   [{:block-type :input
                :label      "Source name"
                :required   true
                :name       :name
                :value      ""}

               {:block-type :input
                :label      "Description"
                :name       :description
                :value      ""}

               {:block-type :select
                :label      "Access Type"
                :name       :access-type
                :options    [{:name "URL" :value "url"}
                             {:name "Manual" :value "manual"}]
                :required   true
                :value      "manual"}

               {:block-type :input
                :label      "Hostname"
                :name       :hostname
                :required   true
                :value      ""
                :conditions [[:eq [:access-type :value] "manual"]]}

               {:block-type :input
                :label      "Port"
                :name       :port
                :value      ""
                :conditions [[:and [[:access-type :value] [:srv-conn? :value]] ["manual" false]]]}

               {:block-type :input
                :label      "Database User"
                :name       :user
                :required   true
                :value      ""
                :conditions [[:eq [:access-type :value] "manual"]]}

               {:block-type :input
                :label      "Database Password"
                :name       :password
                :type       :password
                :required   true
                :value      ""
                :conditions [[:eq [:access-type :value] "manual"]]}

               {:block-type :input
                :label      "Database Name"
                :name       :dbname
                :required   true
                :value      ""
                :conditions [[:eq [:access-type :value] "manual"]]}

               {:block-type :input
                :label      "Auth Database Name"
                :name       :auth-dbname
                :required   true
                :value      "admin"
                :conditions [[:eq [:access-type :value] "manual"]]}

               {:block-type :checkbox
                :label      "Use mongo+srv connection (e.g. for Atlas)"
                :name       :srv-conn?
                :type       :checkbox
                :value      false
                :conditions [[:and [[:access-type :value] [:has-bastion? :value]] ["manual" false]]]}

               {:block-type :input
                :label      "URL"
                :name       :url
                :required   true
                :value      ""
                :conditions [[:eq [:access-type :value] "url"]]}

               {:block-type :input
                :label      "Extra Parameters"
                :name       :extra
                :value      ""}

               {:block-type :checkbox
                :label      "Requires tunneling"
                :name       :has-bastion?
                :type       :checkbox
                :value      false
                :conditions [[:eq [:srv-conn? :value] false]]}

               {:block-type :subtitle
                :content    "Bastion host"
                :conditions [[:eq [:has-bastion? :value] true]]}

               {:block-type    :input
                :label         "Bastion Hostname"
                :name          :bastion-hostname
                :required      true
                :value         ""
                :default-value ""
                :conditions [[:eq [:has-bastion? :value] true]]}

               {:block-type    :input
                :label         "Bastion User"
                :name          :bastion-user
                :value         ""
                :default-value ""
                :required      true
                :conditions    [[:eq [:has-bastion? :value] true]]}

               {:block-type    :input
                :label         "Bastion Port"
                :name          :bastion-port
                :value         "22"
                :default-value "22"
                :required      true
                :conditions    [[:eq [:has-bastion? :value] true]]}

               {:block-type :file-input
                :label      "Private key file"
                :name       :private-key
                :required   true
                :type       :password
                :conditions [[:eq [:has-bastion? :value] true]]}

               {:block-type :submit
                :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [action collection description destination-table extract-type
                 name ordering status]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]
       :config        {:extracts [(app.utils/keep-non-nil-keys
                                   {:action            action
                                    :collection        collection
                                    :destination-table destination-table
                                    :extract-type      extract-type
                                    :ordering          ordering})]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config source-id]} data
            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:action :collection :destination-table :extract-type :ordering])
         (app.utils/keep-non-nil-keys
          {:name        name
           :description description
           :status      status
           :source-id   source-id}))))

    :validate (constantly nil)

    :id       :mongodb-extract-form

    :blocks   [{:block-type :input
                :label      "Extract name"
                :required   true
                :name       :name
                :value      ""}

               {:block-type :input
                :label      "Description"
                :name       :description
                :value      ""}

               {:block-type :select
                :label      "Status"
                :name       :status
                :options    [{:name "Active" :value "active"}
                             {:name "Paused" :value "paused"}]
                :required   true
                :value      "active"}

               {:block-type :subtitle
                :content    "Extract configuration"}

               {:block-type :form-value
                :name       :source-id}

               {:block-type :input
                :label      "Collection Name"
                :name       :collection
                :required   true}

               {:content "The ordering will only affect the way we determine where to start and stop with incremental extractions"}

               {:block-type :select
                :label      "Ordering"
                :name       :ordering
                :options    [{:name "Timestamp" :value "timestamp"}
                             {:name "ObjectId"  :value "objectid"}]
                :required   true
                :value      "timestamp"}

               {:content    "Timestamp ordering is more likely to cause duplicates if a lot of documents are created within the same second"
                :conditions [[:eq [:ordering :value] "timestamp"]]}

               {:content    "ObjectId ordering will filter by the incorporated counter but may, in rare cases, miss a document in big clusters"
                :conditions [[:eq [:ordering :value] "objectid"]]}

               {:block-type :subtitle
                :content    "Data loading options"}

               {:block-type :select
                :label      "Load method"
                :name       :action
                :options    [{:name "Drop, Create, Load" :value "replace"}
                             {:name "Truncate, Load"     :value "reload"}
                             {:name "Append"             :value "append"}]
                :required   true
                :value      "replace"}

               {:block-type :select
                :label      "Extract type"
                :name       :extract-type
                :options    [{:name "Incremental" :value "incremental"}
                             {:name "Full"        :value "backfill"}]
                :required   true
                :value      "incremental"}

               {:content "Drop table, Create table, load entire table (selected columns)"
                :conditions [[:eq [:action :value] "replace"]]}

               {:content "Truncate table, Load entire table (selected columns)"
                :conditions [[:eq [:action :value] "reload"]]}

               {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
                :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "backfill"]]]}

               {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
                :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}

               {:block-type :subtitle
                :content    "Destination table"}

               {:block-type  :warehouse-destination
                :name        :destination-table}

               {:block-type :submit
                :content    "SAVE"}]}})



(comment
 ;; These could also be potentially implemented for mongo as you can request the names of databases (mongo version of schemas) and collection (mongo version of tables). you could potentially do columns as well but that's.. not gonna work for this.
 {:block-type        :database-metadata-select
  :label             "Schema"
  :loading-text      "Loading schemas..."
  :disabled-text     "Select schema"
  :empty-option-text "Select schema"
  :required          true
  :value             ""
  :name              :source-schema

  :options-sub       :connections.subs/database-schemas
  :upstream-deps     []
  :downstream-deps   [:source-table :update-column :columns]}


 {:block-type        :database-metadata-select
  :label             "Table"
  :loading-text      "Loading tables..."
  :disabled-text     "Select table"
  :empty-option-text "Select table"
  :required          true
  :value             ""
  :name              :source-table

  :skip-request      true
  :options-sub       :connections.subs/database-tables
  :upstream-deps     [:source-schema]
  :downstream-deps   [:update-column :columns]})
